module.exports = __webpack_public_path__ + "img/illeage.d6ff25d7.png";